module.exports = __webpack_public_path__ + "static/media/blade_bow.a8ea4d61.png";